import {PHASES} from "../../constants/phases";
import {getRankSkinFramePath} from "../factions/getRankSkinFramePath";
import {parseRankSkinId} from "../factions/getFactionRankSkinTitle";

// Состояние хода игрока на его карточке в списке игроков и кружке в строке
// игроков шапки (см. getTurnStatus)
export const PLAYER_TURN_STATUSES = Object.freeze({
  ACTING: 'acting', // ходит сейчас или еще не закончил (одновременные фазы)
  DONE: 'done', // уже походил в этой фазе
  NONE: 'none',
});

/**
 * Вид бегущей полосы ходящего: у рейтингового образа с рамкой (золотой,
 * алмазной, рубиновой) — своя полоса, у остальных — белая (PlayerInfo.css,
 * кольцо — HeaderPlayersRow.css)
 * @param {string} [skinId]
 * @returns {string|undefined} лига образа или undefined
 */
export const getRankStripe = (skinId) => (
  getRankSkinFramePath(skinId) ? parseRankSkinId(skinId).rank : undefined
);

/**
 * Ходит ли игрок, походил ли уже. Вместо значков в строке — вид всей
 * карточки: бегущая по периметру полоса у ходящих, вдавленная плита у
 * походивших; в строке игроков шапки — кольцо вокруг кружка
 */
export const getTurnStatus = (
  playerId,
  currentPlayer,
  phase,
  playersConfirmedSetupPhase,
  phaseCompletedPlayers,
  isParallelSupplyPhase
) => {
  if (phase === PHASES.SETUP) {
    return playersConfirmedSetupPhase.includes(playerId) ?
      PLAYER_TURN_STATUSES.NONE
      : PLAYER_TURN_STATUSES.ACTING;
  }

  // Одновременная фаза снабжения: ждем каждого, кто еще не закончил свою
  // часть. Текущий игрок здесь заморожен и ничего не значит — проверять его
  // раньше завершивших нельзя, иначе он остался бы «ходящим» после завершения
  if (isParallelSupplyPhase) {
    return (phaseCompletedPlayers || []).includes(playerId) ?
      PLAYER_TURN_STATUSES.DONE
      : PLAYER_TURN_STATUSES.ACTING;
  }

  if (currentPlayer.id === playerId) {
    return PLAYER_TURN_STATUSES.ACTING;
  }

  return phaseCompletedPlayers.includes(playerId) ?
    PLAYER_TURN_STATUSES.DONE : PLAYER_TURN_STATUSES.NONE;
}
